import axios from 'axios'
import React, {useEffect, useState, useMemo, useRef } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate, useParams } from 'react-router-dom'
import styled from 'styled-components';
import { LOAD, LOAD_END, LOGOUT, SELECT_CLIENT } from '../../../../../../store/actions/actionsTypes';
import ControlButton from '../../../../../generic/buttons/ControlButton';
import Title from '../../../../../generic/Title/Title';
import TitlesList from '../../../../../generic/titlesRowItem/TitlesList';
import { checkPackType } from '../../../../../generic/utils/checkPackType';
import { DELETE_FROM_PALLET, GET_PALLET_EXIST } from '../../../../../modules/API/settings'
import { LINKS } from '../../../../../Routs/config';
import { Decorator, MainWrapper } from '../../../../../generic/Layouts/OrderlikeLayout';
import { ContentWrapper } from '../../../../../generic/Layouts/orderListStyles';
import useDataFetcher from '../../knisot/hooks/useFetchData';
import { Defaults } from '../../../../../modules/API/Defaults/defaults';
import { useAddProductFormService } from '../../market/Collect/services/hooks/useAddProductFormService';
import selectBrodMigdal from '../../../../../generic/utils/selectBrodMigdal';
import AddProductModal from '../../market/Collect/Components/AddProductModal';
import ColumModal from '../../../../../generic/Layouts/ColumModal';
import { AppModal } from '../../../../../generic/ui/Modal';
import { Pallets } from '../../../../../modules/API/Pallets/pallets';
import PalletDetailesItem from './PalletDetailesItem';
import ProductModal from '../../market/Collect/Components/ProductModal';
import { useTranslation } from 'react-i18next'
import PalletDetailsTitle from './PalletDetailsTitle';
import TitleModalContent from './TitleModalContent';
import { handleNotifications } from '../../../../../generic/utils/handleNotifications';
import { useProductCreationFieldsControl } from '../../settings/FeatureControl/services/hooks/useProductCreationFieldsControl';


const ControlButtosWrapper = styled.div`
    width: 100%;
    display: flex;
    gap: 0.5em;
`

export default function AddPalletDetailes({
    clientList, clientListDefault, setClientList,
    getPalletCurrent
}) {
    const [t] = useTranslation('controllPallet')
    const { id } = useParams();
    const defaults = useSelector((state) => state.defaults.defaults)
    const defaultPackage = selectBrodMigdal(defaults, 382, 'Num_Value');
    const sellerID = useSelector((state) => state.mainReducer.user?.code_internal)
    const navigate = useNavigate()
    const token = useSelector(e => e.mainReducer.token);
    const packagesList = useSelector(e => e.defaults?.packageList);
    const controlPalletsReduxState = useSelector(e => e.controlPallets);
    const defaultArizaTranzit = useSelector(item => item.defaults.defaults.filter(e => e.Int_ID === 5)[0]?.Num_Value);
    const defaultPalletType = useSelector(item => item.defaults.defaults === null ? '' : item.defaults.defaults.filter(e => {
        return e.Int_ID === 14 && e?.Sub_ID?.trim() === '1'
    })[0]?.Num_Value)
    const dispatch = useDispatch();
    const [palletRows, setPalletRows] = useState([]);
    // client select component states
    const clientInputDefault = controlPalletsReduxState?.client?.name?.trim() || ''
    const clientIDDefault = controlPalletsReduxState?.client?.id || null
    const customerIDRef = useRef(clientIDDefault)
    const [clientInput, setClientInput] = useState(clientInputDefault);
    const [clientID, setClientID] = useState(clientIDDefault);
    const [isShowClientList, setIsShowClientList] = useState(false);
    const [isOpenAddProduct, setIsOpenAddProduct] = useState(false)
    const [tranzitID, setTranzitID] = useState(defaultArizaTranzit)
    const [isOpenTitleModal, setIsOpenTitleModal] = useState(id === 'new')
    const [externalPalletNumber, setExternalPalletNumber] = useState('');

    const {
        productCreationFields,
        productCreationFieldsDict,
        isLoading: isLoadingProductCreationFields,
    } = useProductCreationFieldsControl();
    const {
        data: dataWarehouses
    } = useDataFetcher(
        Defaults.getWarhouseList, "data"
    )

    const getExistPalletInfo = async (id) => {
        dispatch({ type: LOAD })
        try {
            let res = await axios.get(`${GET_PALLET_EXIST}${id}`, {
                headers: {
                    'Authorization': 'Bearer ' + token
                }
            })
            setPalletRows(res.data.detailsPallet);
        }
        catch (err) {
            console.log(err)
        } finally {
            dispatch({ type: LOAD_END })
        }
    }
    const deleteItemFromPallet = async (id) => {
        dispatch({ type: LOAD })
        try {
            let res = await axios({
                method: 'delete',
                headers: {

                    'Authorization': 'Bearer ' + token

                },
                url: DELETE_FROM_PALLET + id
            })
            const filtered = palletRows.filter(item => item.RecID !== id);
            setPalletRows(filtered);
            handleNotifications(res?.data?.message, {type: 'success'})
        } catch (err) {
            handleNotifications(err?.response?.data?.message, {type: 'error'})
            
            if (err.response?.data.message === 'jwt malformed' || err.response?.data.message === 'jwt expired') {
                dispatch({ type: LOGOUT, payload: false });
            }
        } finally {
            dispatch({ type: LOAD_END })
        }
    }

    useEffect(() => {
        if (id !== 'new') {
            getExistPalletInfo(id)
        }
    }, [id])

    const clientFilter = (input) => {
        const filtered = clientListDefault.filter(e => e.Customer_Name.trim().toLowerCase().includes(input.toLowerCase()));
        setClientInput(input);
        setClientList(filtered);
        setIsShowClientList(filtered.length > 0 && input ? true : false);
        if (!input.trim()) {
            setClientID(null)

        }
    }

    const selectClient = (id, name) => {
        setClientID(id);
        setClientInput(name);
        setIsShowClientList(false);
        dispatch({ type: SELECT_CLIENT, name: name, id: id })

    }

    const putCustomerToPallet = async () => {
        if (customerIDRef?.current) return handleClickLeavePage()
        if (!clientIDDefault?.current && !clientID) return handleClickLeavePage()
        dispatch({ type: LOAD })
        const data = {
            CustomerID: clientID || 0,
        }
        try {
            Pallets.putCustomerToPallet(id, data)
            handleNotifications(t('controllPallet_customerUpdated'), {type: 'success'})
            handleClickLeavePage()
        } catch (error) {
            handleNotifications(t('controllPallet_customerNotUpdated'), {type: 'error'})
        } finally {
            dispatch({ type: LOAD_END })
        }
    }

    const handleClickLeavePage = () => {
        getPalletCurrent();
        navigate(LINKS.mishtahim.control.mainURL)
    }

    const handleOpenAddProduct = () => {
        setIsOpenAddProduct(!isOpenAddProduct)
    }

    const {
        data: dataPallets
    } = useDataFetcher(
        Pallets.getPalletList, "data"
    )

    const {
        qualityList,
        productList: dataProductsTypesWithID,
        growerList,
        sizeData,
        getSizes,
        createProduct,
        updateProduct: serviceUpdateProduct,
    } = useAddProductFormService({
        warehouseID: tranzitID || 0,
        defaultPalletType,
        extraCreatePayload: {
            ExternalNum: +externalPalletNumber,
            Reseller_Code: sellerID ? +sellerID : 0,
        },
        onCreateSuccess: (res) => {
            handleOpenAddProduct()
            setPalletRows(res.lines18)
            navigate(`${LINKS.mishtahim.control.create}${res.palletNum}`);
        },
        onUpdateSuccess: (res) => {
            patchProduct(res)
            handleOpenProductEdit()
        },
        onUpdateError: (err) => console.log(err),
    })

    const selectedPallet = useMemo(() => {
        return {
            pallet: id !== 'new' ? +id : 0,
            client: clientID,
            name: ''
        }
    }, [id, clientID])

    const [selectedProduct, setSelectedProduct] = useState(null)
    const [isOpenEditProduct, setIsOpenEditProduct] = useState(false)

    const handleOpenProductEdit = () => {
        setIsOpenEditProduct(!isOpenEditProduct)
    }

    const handleSelectProduct = (product) => {
        setSelectedProduct(product)
        handleOpenProductEdit()
    }

    const patchProduct = (data) => {
        if(!selectedProduct) return
        const tempArr = [...palletRows]
        const result = tempArr.map(item => {
            let result = item
            if(item.RecID === selectedProduct.RecID) {
                result = {
                    ...item,
                    ...data
                }
            }
            return result
        })
        setPalletRows(result)
    }

    const updateProduct = async (data) => {
        if (!selectedProduct) return
        await serviceUpdateProduct(selectedProduct.RecID, data)
    }
    const handleDelete = async (id) => {
        // dispatch({ type: LOAD })
        try {
            await Pallets.deleteProductFromPallet(id)
            const filtered = palletRows.filter(item => item.RecID !== id);
            setPalletRows(filtered);
            handleNotifications(t('controllPallet_itemDeleted'), {type: 'success'})
            
        } catch (err) {
            handleNotifications(err?.response?.data?.message, {type: 'error'})
        } finally {
            // dispatch({ type: LOAD_END })
        }
    }

    const addProductModalProps = {
        data: selectedPallet,
        dataGrowers: growerList,
        dataPallets: dataPallets,
        packageList: packagesList,
        sellerID: sellerID,
        defaultPallet: defaultPalletType,
        defaultPackage: defaultPackage,
        createProduct: createProduct,
        cashProduct: () => { },
        dataProductsWithVariety: dataProductsTypesWithID,
        getSizes: getSizes,
        sizeData: sizeData,
        qualityList: qualityList || [],
        productCreationFieldsDict: productCreationFieldsDict,
        productCreationFields: productCreationFields,
    }

    const productEditProps = {
        data: selectedProduct,
        updateProduct: updateProduct,
        packageList: packagesList,
        growers: growerList?.growers || [],
        pallets: dataPallets?.pallets,
        dataProductsWithVariety: dataProductsTypesWithID,
        getSizes: getSizes,
        sizeData: sizeData,
        qualityList: qualityList || [],
    }
    
    const totalPackages = useMemo(() => {
        return palletRows.reduce((sum, item) => sum + (item.Quantity || 0), 0);
    }, [palletRows]);

    const totalWeight = useMemo(() => {
        return palletRows.reduce((sum, item) => sum + (item.WeightNeto || 0), 0);
    }, [palletRows]);

    const warehouseName = useMemo(() => {
        return dataWarehouses?.find(w => w.WarehouseID === tranzitID)?.WarehouseDesc || '';
    }, [dataWarehouses, tranzitID]);

    const handleOpenTitleModal = () => {
        setIsOpenTitleModal(!isOpenTitleModal)
    }

    const handleExternalPalletNumberChange = (value) => {
        setExternalPalletNumber(value);
    };

    const title = id === 'new' ? t('controllPallet_newPalletTitle') : t('controllPallet_palletWithId', { id })

    return (
        <MainWrapper>
            <Decorator />
            <Title label={title} />
            
            <PalletDetailsTitle 
                customerName={clientInput}
                warehouseName={warehouseName}
                totalPackages={totalPackages}
                totalWeight={totalWeight}
                onEditClick={handleOpenTitleModal}
            />
            
            {isOpenTitleModal && (
                <ColumModal
                    title={title}
                    Children={TitleModalContent}
                    controlFunc={handleOpenTitleModal}
                    childrenProps={{
                        clientInput,
                        clientFilter,
                        isShowClientList,
                        clientList,
                        selectClient,
                        clientIDDefault,
                        dataWarehouses,
                        tranzitID,
                        defaultArizaTranzit,
                        setTranzitID,
                        externalPalletNumber,
                        onExternalPalletNumberChange: handleExternalPalletNumberChange,
                        isDisabled: id !== 'new'
                    }}
                />
            )}
            
            {isOpenAddProduct && (
                <AppModal
                    title={id === 'new' ? t('controllPallet_newPalletTitle') : t('controllPallet_palletWithId', { id })}
                    Children={AddProductModal}
                    controlFunc={handleOpenAddProduct}
                    childrenProps={addProductModalProps}
                    size='sm'
                />
            )}
            
            {isOpenEditProduct && (
                <AppModal
                    title={t('controllPallet_updateItem')}
                    Children={ProductModal}
                    controlFunc={handleOpenProductEdit}
                    childrenProps={productEditProps}
                    size='sm'
                />
            )}
            
            <ContentWrapper>
                <TitlesList
                    list={palletRows}
                    uniqueKey={'RecID'}
                    Element={PalletDetailesItem}
                    additionalData={{
                        withoutOpacity: true,
                        likutWithoutAzmana: true,
                        deleteFromPallet: deleteItemFromPallet,
                        handleSelectProduct: handleSelectProduct,
                        handleDelete: handleDelete
                        
                    }}
                />
            </ContentWrapper>
            
            <ControlButtosWrapper>
                <ControlButton
                    handleClick={putCustomerToPallet}
                    lable={t('controllPallet_finish')}
                />
                {
                    <ControlButton
                        handleClick={handleOpenAddProduct}
                        lable={t('controllPallet_newProduct')}
                    />
                }
            </ControlButtosWrapper>
        </MainWrapper>
    )
}
